export default {
      id: "vague-footer-2000-usage",
      viewBox: "0 0 2000 296.44",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#vague-footer-2000-usage",
      toString: function () {
        return this.url;
      }
    }